<template>
  <cms-about
    v-if="aboutSetUp"
    :theme="aboutOptions"
    :content="aboutContentByVersion"
    :watermark="watermarkLogo"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import isEmpty from 'lodash/isEmpty';
import { stripHtml } from '../../../../helpers/strings.js';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);
const aboutContent = computed(() => mainStore.aboutContent);
const globals = computed(() => mainStore.globals);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const aboutOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: translationStore.getComponentTranslation('about'),
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

const aboutSetUp = computed(() => {
  const content = homepage.value.about?.[id.value] || {};
  const hasContent =
    (content.has_image && !isEmpty(content.image)) ||
    !isEmpty(content.links) ||
    !isEmpty(stripHtml(content.component_text));
  return hasContent;
});

const watermarkLogo = computed(() => globals.value.watermark?.url);

const aboutContentByVersion = computed(() =>
  isThemePreview.value ? aboutContent.value[aboutOptions.value.version] : homepage.value.about[id.value],
);
</script>
